<template>
  <div class="w100 cpfa">
    <div class="flexslider">
      <ul class="slides">
        <div
          class="lunBotu"
          :style="{ background: 'url(' + require('@/assets/' + Product['background']) + ')' }"
        >
          <div class="container">
            <div class="ban2 float">
              <!-- 产品名称 -->
              <!-- <div
                class="product"
                :style="{ background: 'url(' + require('@/assets/' + Product['product']) + ') no-repeat ' }"
              >-->
              <!-- <span class="reg">&reg;</span> -->
              <!-- <div class="desc">{{Product['desc']}}</div> -->
              <div class="product-h2">{{Product['h2']}}</div>
              <!-- <div class="shenqing" @click="gotoTIyan">申请体验</div> -->
              <!-- </div> -->
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    Product: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    // 跳转到商业合作的位置
    getCooperate () {
      document.getElementById('submit').scrollIntoView()
    },
    // 跳转到下载文件的位置
    gotodownload () {
      document.getElementById('download').scrollIntoView()
    },
    gotoTIyan () {
      document.getElementById('toFormFree').scrollIntoView()
    }
  }
}
</script>

<style scoped>
.flexslider {
  position: relative;
  height: 360px;
  overflow: hidden;
  z-index: 1;
  clear: both;
  margin-top: -250px;
}
.cpfa .container .float {
  width: 800px;
  margin: 0 auto;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -400px;
  margin-top: 60px;
}
.cpfa .container .cpxl {
  float: left;
  margin-top: 49px;
  margin-left: 0px;
}
.banner {
  width: 42%;
}
.cpfa .container img {
  max-width: 560px;
  margin-top: 30px;
}
/* 产品 */
.product {
  position: relative;
}

.product-h2 {
  font-size: 70px;
  font-weight: bold;
  font-family: "siyanyahei";
  width: 800px;
  color: rgba(255, 255, 255, 1);
  margin-top: -34px;
  text-align: center;
}
.shenqing {
  font-size: 26px;
  font-weight: normal;
  color: rgba(254, 254, 254, 1);
  width: 150px;
  height: 50px;
  line-height: 50px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 39px;
}
.lunBotu {
  margin-top: -80px;
  z-index: 1;
  background-size: 100% 100%;
  height: 405px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/form/banner.vue